import { h } from 'preact';
import { Checkbox } from 'DesignSystem';
import { List } from 'adapters/list/graphqlTypes';
import translate from 'helpers/utils/translate';
import Choice, { ChoiceItem } from 'DesignSystem/Choice';

type ListProps = {
    lists: List[];
    onChange: (listId: string, name: string, checked: boolean) => void;
};

const CompactLists = ({ lists, onChange }: ListProps) => {
    return (
        <Choice>
            {lists.map(({ listId, retail: { items }, name }) => {
                const image =
                    items[items.length - 1]?.product?.images?.find(({ quality }) => quality === 'S1')?.url ?? ' ';
                return (
                    <ChoiceItem
                        id={listId}
                        key={listId}
                        image={{
                            src: image,
                            alt: name,
                        }}
                        title={name || translate('Default list name')}
                        caption={
                            <Checkbox
                                data-testid={`${listId}_checkbox`}
                                onChange={(e: any) => onChange(listId, name, e.target.checked)}
                                id={`select-${listId}`}
                                value=""
                            />
                        }
                    />
                );
            })}
        </Choice>
    );
};

export default CompactLists;
